import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ListTable from 'components/table/ListTable';
import { useUIUtils } from 'hooks/useUIUtils';
import { currency } from 'resources/utilities';
import { nombreEstatus, nombreTipoDocto, sucursalActual } from '../comun';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

const List = ({ match }) => {
    const { path } = match;
    const { changeGlobalTitle } = useUIUtils();
    const [tipo, setTipo] = useState('T');

    React.useEffect(() => {
        changeGlobalTitle('Documentos', 'Ordenes, ventas, devoluciones y cobros del punto de venta.');
    }, [changeGlobalTitle]);

    const columns = [
        { field: 'folio', headerName: 'Folio', minWidth: 120, renderCell: (params) => <Link to={`${path}/ver/${params.row.id}`}>{params.value || params.row.id}</Link> },
        { field: 'tipo_Docto', headerName: 'Tipo', minWidth: 120, valueGetter: (value) => nombreTipoDocto(value) },
        { field: 'estatus', headerName: 'Estatus', minWidth: 110, valueGetter: (value) => nombreEstatus(value) },
        { field: 'fecha', headerName: 'Fecha', minWidth: 120, valueGetter: (value) => String(value || '').slice(0, 10) },
        { field: 'clave_Cliente', headerName: 'Cliente', minWidth: 140 },
        { field: 'total_Importe', headerName: 'Total', minWidth: 120, valueGetter: (value) => currency(value) },
        { field: 'acciones', headerName: '', minWidth: 80, sortable: false, renderCell: (params) => <Link to={`${path}/ver/${params.row.id}`}>Ver</Link> }
    ];

    const FiltroTipoDocumento = () => {
        return (<FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="tipo-categoria-checkbox-label">Tipo Documento</InputLabel>
            <Select onChange={({ target }) => setTipo(target.value)} value={tipo} label="Tipo Documento">
                <MenuItem key='T' value='T'><ListItemText primary='Todos' /></MenuItem>
                <MenuItem key='O' value='O'><ListItemText primary='Ordenes' /></MenuItem>
                <MenuItem key='V' value='V'><ListItemText primary='Ventas' /></MenuItem>
                <MenuItem key='D' value='D'><ListItemText primary='Devoluciones' /></MenuItem>
                <MenuItem key='P' value='P'><ListItemText primary='Cobros CxC' /></MenuItem>
            </Select>
        </FormControl>);
    };
    const GetTipoDocto = () => tipo === 'T' ? '' : tipo;

    return (
        <div className='container-fluid'>
            <div className='col-md-12'>
                <ListTable
                    columns={columns}
                    path={path}
                    hideFiltroExtra
                    filtroExtra={FiltroTipoDocumento()}
                    url={`pv/PvDocumentos/GetList?sucursal_Id=${sucursalActual()}&tipo_docto=${GetTipoDocto()}&estatus=&cliente_id=0&caja_id=0&fechaInicio=&fechaFin=`}
                />
            </div>
        </div>
    );
};

export { List };
